<template>
  <div id="app">
    <navbar v-if="this.$store.getters.isLoggedIn"/>
    <router-view :key="$route.fullPath" />
    <Footer v-if="this.$store.getters.isLoggedIn"/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        document.title = 'Img-Lib - ' + to.meta.title
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue